// ============================================================================
// FNE-BRIDGE Frontend - Thème MUI (light + dark)
// ============================================================================

import { createTheme, type ThemeOptions } from '@mui/material/styles';
import { palette, darkPalette } from './palette';
import { typography } from './typography';
import { components } from './components';

// --- Options communes ---
const baseOptions: ThemeOptions = {
  typography,
  components,
  shape: {
    borderRadius: 8,
  },
  spacing: 8,
  transitions: {
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195,
    },
  },
};

// --- Thème clair ---
export const lightTheme = createTheme({
  ...baseOptions,
  palette: {
    mode: 'light',
    ...palette,
  },
});

// --- Thème sombre ---
export const darkTheme = createTheme({
  ...baseOptions,
  palette: {
    mode: 'dark',
    ...darkPalette,
    success: palette.success,
    error: palette.error,
    warning: palette.warning,
    info: palette.info,
  },
});

export { palette, darkPalette };
